function resizeWindow(){
	//Home Gallery
	if( $(window).width() >=800 ){
		var linkwidth = ( $(window).width() - 8 ) / 5;	
	}else{
		var linkwidth = ( $(window).width() - 2 ) / 2;
	}
	$('#home .main-content .home-gallery a').css('width', linkwidth + 'px');
	//Content copy height fixing
	if( $('body.drink-and-dine').length > 0 || $('body.our-hotel').length > 0 ){
	if( $('body#default #content .bg .content .bottom-copy .container .copy').height() > 600 ){
		var imgH = $('body#default #content .bg .content .bottom-copy .container .copy').height() + 60;
		//$('body#default #content .bg .content .bottom-copy .container .image').css('height', imgH + 'px');
		}
	}
	//tablet gallery
	if( $(window).width() > 1090 && $('body#gallery').length > 0 ){
		hideArrows();	
	}


	

}
function scrollDown(){
	if( $(window).scrollTop() > 80){
		$('#header').addClass('down');
	}else{
		$('#header').removeClass('down');
	}
}

$(window).bind("load", function () {
	
	equalize();
	$(document).ready(function () {
		
		//Map back button addition
		if( $('body#map').length > 0 ){
			$('#content.map').append('<a class="map_back" href="javascript:history.back()">Back to previous page</a>');
		}
		
		$('body#map-category #content').prepend('<a role="complementary" class="btn Ada-Page" href="/ada-things-to">« Click here for accessible list of local attractions</a>');
		
		//Tablet gallery arrows
		$('#gallerymontage a').click(showArrows);
		$('.gallery_close').click(hideArrows);

		//Load position header
		if( $(window).scrollTop() > 80){
			$('#header').addClass('down');
		}else{
			$('#header').removeClass('down');
		}
	
		//Call function with browser is resized.
        $(window).resize(function (event) {
             resizeWindow();
        });
        resizeWindow();

        //Acts when scroll down page.
        $(window).scroll(function (event) {
        	scrollDown();
			var top = $(document).scrollTop();
			if (top > 0) {

			} else {

			}
		});
		
		//Expandible menu book benefits
		$('#header-benefits h2').click(showBenefits);
		
		//Booking engine show
		$('.booking_button').click(showBooking);
		
		//Full menu show
		$('#header .main-menu .burger').click(showfullMenu);

		//Home quads toggle
		$('#home .main-content .home-quads .quads-nav a').click(function(e){
			e.preventDefault();
			$('#home .main-content .home-quads .quads-nav a').removeClass('active');
			$(this).addClass('active');
			$('#home .home-quads .content_block').removeClass('active');
			var current = $(this).attr('href');
			
			$('#home .home-quads ' + current).addClass('active');
		});


		//Home page scroll down arrow. If present.
		$('.arrow-home').click(function(event) {
		    $('body, html').animate({
		        scrollTop: $(window).height()-$('header').outerHeight()},
		        800, 'easeOutExpo');

		});
		
		

		//Slick Slider
		$('.sym-slides').slick();
		
		//home specials slick
		$('.home-specials .container').slick({
			accessibility: true,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		});
		//home testimonials slick
		$('.home-map .testimonials').slick({
			accessibility: false,
			arrows: false,
			dots: true,
			fade: true,
			cssEase: 'linear'
		});
		
		
		
		
		
		
		//Accommodations 
		//If there is not any image
		$('#accommodations .room').each(function(){
			if($(this).find('.overview').hasClass('no-image') ){
				$(this).find('.overview').addClass('open');	
			}
		});
		//Accommodations over
		$('#accommodations .room').click(showAccommodations);
		$('#accommodations .room').mouseover(function(){
			//if there is not any image on the accommodation
			if( $(this).find('.overview').hasClass('no-image') ){
				
			}else{
				$(this).find('.overview').addClass('open');
			}
			
		});
		$('#accommodations .room').mouseout(function(){
			if( $(this).find('.overview').hasClass('no-image') ){
				
			}else{
				$(this).find('.overview').removeClass('open');
			}
			
		});
		//Specials over
		$('#specials .special').click(showAccommodations);
		$('#specials .special').mouseenter(function(){
			//if there is not any image on the accommodation
			if( $(this).find('.overview').hasClass('no-image') ){
				
			}else{
				$(this).find('.overview').addClass('open');
			}
			
		});
		$('#specials .special').mouseleave(function(){
			if( $(this).find('.overview').hasClass('no-image') ){
				
			}else{
				$(this).find('.overview').removeClass('open');
			}
			
		});


		//Event Tracking
        $('.book-now').on('click', function () {
             ga('send', 'event', 'reservations', 'click', 'book now');
        });
        $('.bookNow').on('click', function () {
             ga('send', 'event', 'header widget', 'click', 'book now');
        });

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			minDate: 0,
			onSelect: function( selectedDate ) {
				getDate = $(this).datepicker('getDate');
            	newDate = new Date(getDate.getTime());
            	newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			onSelect: function( selectedDate ) {
				$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		
		//Sitemap 
		if( $('body.sitemap').length > 0 ){
			$('#top-content h1').html('Sitemap');
			//link hide
			$('ul.global-sitemap li').each(function(){
				if( $(this).find('a').text() == 'Sitemap'){
					$(this).hide();
				}
			});
			
		}
		
		//homebanner arrow
		$('#home .top-content .home-banner-wrap .arrow').click(hideBanner);
		
		//home badge 
		$('#home .banner-wrap .arrow').click(showBadge);

		//Remove attributes
		$('#third-nav').removeAttr('aria-labelledby');
		
     });
});

//reveal ammenities on accommodations
  $('.revealBox').click(function(e) {
	e.preventDefault();
	$('.sym-inline-list ').toggleClass('son-g');
});



function showBooking(){
	$('#booking-form').addClass('open');
	if($(window).width() <= 1024 && $('.booking_button').hasClass('full') ){
		$('#booking-form').addClass('full');
	}
	$(this).unbind('click');
	$(this).click(hideBooking);
}
function hideBooking(){
	$('#booking-form').removeClass('open');
	$(this).unbind('click');
	$(this).click(showBooking);
}
function showfullMenu(){
	$('#header .main-menu .burger').addClass('close');
	$('#header #primary-nav').addClass('open');
	$('#header a.logo').addClass('open');
	$('#header #primary-nav ul').wrap('<div class="table"></div>');
	$('body').addClass('overflow');
	
	//Booking button change on Tablet
	if($(window).width() <= 1024 ){
		$('.booking_button').addClass('full');
		$('#booking-form').addClass('full');
	}
	$(this).unbind('click');
	$(this).click(hidefullMenu);
	//add Secondary menu and social at bottom 
	$('#header #secondary-nav').fadeIn(500);
	$('#header #header-social').fadeIn(500);
	$('#header #header-benefits').fadeIn(500);
	
}
function hidefullMenu(){
	//hide Secondary menu and social at bottom 
	$('#header #secondary-nav').fadeOut(100);
	$('#header #header-social').fadeOut(100);
	$('#header #header-benefits').fadeOut(100);
	$('#header .main-menu .burger').removeClass('close');
	$('#header #primary-nav').removeClass('open');
	$('#header a.logo').removeClass('open');
	if ( $('#header #primary-nav ul').parent().is( "div.table" ) ) {
    	$('#header #primary-nav ul').unwrap();
  	}
  	//Booking button change on Tablet
	if($(window).width() <= 1024 ){
		$('.booking_button').removeClass('full');
		$('#booking-form').removeClass('full');
	}
  	$('body').removeClass('overflow');
	$(this).unbind('click');
	$(this).click(showfullMenu);
}
function showAccommodations(){
	//if there is not any image on the accommodation
	if( $(this).find('.overview').hasClass('no-image') ){
				
	}else{
	
		$(this).find('.overview').addClass('open');
	}
	
	$(this).unbind('click');
	$(this).click(hideAccommodations);
}
function hideAccommodations(){
	//if there is not any image on the accommodation
	if( $(this).find('.overview').hasClass('no-image') ){
				
	}else{
		$(this).find('.overview').removeClass('open');
	}
	
	$(this).unbind('click');
	$(this).click(showAccommodations);
}
function showArrows(){
	if( $(window).width() <= 1090 && $('body#gallery').length > 0 ){
		
		$('.gallery_wrapper').append('<div class="tablet_arrows"><div class="prev"></div><div class="next"></div></div>');
	}
}
function hideArrows(){
	
		$('.tablet_arrows').remove();
	
}
function showBenefits(){
	$(this).parent().addClass('open');
	$(this).unbind('click');
	$(this).click(hideBenefits);
}
function hideBenefits(){
	$(this).parent().removeClass('open');
	$(this).unbind('click');
	$(this).click(showBenefits);
}

function hideBanner(){
	$('#home .top-content .home-banner').addClass('close');
	$(this).addClass('close');
	$('#home .top-content a.menu').hide();
	$(this).unbind('click');
	$(this).click(showBanner);
}
function showBanner(){
	$('#home .top-content .home-banner').removeClass('close');
	$(this).removeClass('close');
	$('#home .top-content a.menu').fadeIn(700);
	$(this).unbind('click');
	$(this).click(hideBanner);
}
function showBadge(){
	$('#home .banner-wrap').addClass('close');
	$('#home .banner-wrap .block').hide();
	$('#home .banner-wrap .arrow').unbind('click');
	$('#home .banner-wrap .arrow').click(hideBadge);
}
function hideBadge(){
	$('#home .banner-wrap').removeClass('close');
	setTimeout(function(){
		$('#home .banner-wrap .block').fadeIn();
	}, 500);
	$('#home .banner-wrap .arrow').unbind('click');
	$('#home .banner-wrap .arrow').click(showBadge);
}
